module.exports = __webpack_public_path__ + "static/media/logo_card02.13c60cbf.png";